module.exports = __webpack_public_path__ + "img/icon_bms3.aaa8328b.jpg";